var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_vm._v(" "+_vm._s(_vm.n)+" "),_c('input',{staticClass:"form-control d-none",attrs:{"type":"file","name":_vm.nn,"accept":_vm.a},on:{"change":function($event){return _vm.$emit('change',$event.target)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }